import PropTypes from 'prop-types'
import OLInteraction from './ol-interaction'
import OlSelect from 'ol/interaction/Select'

export default class Select extends OLInteraction {
  createInteraction(props) {
    return new OlSelect({
      condition: props.condition
    })
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    super.UNSAFE_componentWillReceiveProps(newProps)
    this.selectFeature(newProps.selectedFeature)
  }

  componentDidMount() {
    this.selectFeature(this.props.selectedFeature)
    super.componentDidMount()
  }

  selectFeature(feature) {
    this.interaction.getFeatures().clear()
    if (feature != null) {
      this.interaction.getFeatures().push(feature)
    }
  }
}

Select.propTypes = Object.assign({}, OLInteraction.propTypes, {
  condition: PropTypes.func,
  select: PropTypes.func
})

Select.olEvents = ['select']
